var linkRegex = /#_#.?{(.*?)}.?{(.*?)}.?{(.*?)}/g;

function convertAutoSubmitHtmlToSFMarkdown(htmlMessage) {
  var text = '';
  var myRegexp = /<a href="javascript:autosubmit\('(.*?)'\)">(.*?)<\/a>/g;

  /**
   * #TODO: ----  Get the extra attributes passed in the Anchor tag
   */
  var matches = htmlMessage.match(myRegexp);

  if (matches != null) {
    var lastMatchedIndex = 0;
    matches.forEach((element, elementIndex) => {
      var res = myRegexp.exec(htmlMessage);

      var start = htmlMessage.slice(lastMatchedIndex, res.index);
      var matchLength = res[0].length;
      lastMatchedIndex = res.index + matchLength;

      text += start + `#_#{typeInt}{` + res[1] + `}{` + res[2] + `}`;

      if (elementIndex == matches.length - 1) {
        var end = htmlMessage.slice(
          res.index + matchLength,
          htmlMessage.length
        );
        text += end;
      }
    });
  }

  return text.replace(/<br>/g, '<br/>');
}

function sanitizeMessage(OriginalHtmlMessage) {
  var htmlMessage = MDUtil.convertAutoSubmitHtmlToSFMarkdown(
    OriginalHtmlMessage
  );
  var text = '';
  var matches = htmlMessage.match(linkRegex);

  if (matches != null) {
    var lastMatchedIndex = 0;
    matches.forEach((element, elementIndex) => {
      var res = linkRegex.exec(htmlMessage);
      var obj = { type: res[1], actionValue: res[2], actionLabel: res[3] };
      var start = htmlMessage.slice(lastMatchedIndex, res.index);
      var matchLength = res[0].length;
      lastMatchedIndex = res.index + matchLength;

      text +=
        start +
        `<ActionItem 
                actionLabel="${obj.actionLabel}"
                actionValue="${obj.actionValue}"
                actionType="${obj.type}"
                handleSubmit={handleSubmit}
            />
            `;
      if (elementIndex == matches.length - 1) {
        var end = htmlMessage.slice(
          res.index + matchLength,
          htmlMessage.length
        );
        text += end;
      }
    });
  }

  return text.replace(/<br>/g, '<br/>');
}

let MDUtil = {
  convertAutoSubmitHtmlToSFMarkdown: convertAutoSubmitHtmlToSFMarkdown,
  sanitizeMessage: sanitizeMessage,
  linkRegex: linkRegex
};

export default MDUtil;
